$(document).ready(function() {
    var eventinput = new Event('input', {
        bubbles: true,
        cancelable: true,
    });

    $('body').on('click', '.qty-control span', function() {
        var currentValue = parseInt($(this).siblings('input').val());

        if($(this).hasClass('qty-plus')) {
            $(this).siblings('input').val(currentValue+1).get(0).dispatchEvent(eventinput);
            $(this).siblings('input').trigger('mini-cart-item-qty-updated');
        } else {
            $(this).siblings('input').val(currentValue-1).get(0).dispatchEvent(eventinput);
            $(this).siblings('input').trigger('mini-cart-item-qty-updated');
        }
    });

    $('body').on('click', '.hide-upsell', function() {
        $(".upsell").hide();
    })

    
})
